import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * A React component for displaying a fixed bottom navigation bar, using Bulma's https://bulma.io/documentation/components/tabs/
 *
 * @param {any} props
 * @returns {React.Component}
 */
function Footbar(props) {
  //const { activeRenderer, renderers, setRenderer } = props;

  // const rendererTabs = renderers.map((renderer) => {
  //   return (
  //     <a
  //       key={"activate" + renderer}
  //       className={"navbar-item " + (renderer === activeRenderer ? "is-active" : "")}
  //       onClick={setRenderer.bind(null, renderer)}
  //     >
  //         {renderer}
  //     </a>
  //   );
  // });

  return (
    <nav className="navbar is-fixed-bottom">
        <div className="container">
          <div className={'navbar-menu is-active'}>
						{/* <div className="navbar-start renderers">
							{rendererTabs}
						</div> */}
					</div>
        </div>
    </nav>
  );
}

Footbar.propTypes = {
  activeRenderer: PropTypes.string.isRequired,
  renderers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setRenderer: PropTypes.func.isRequired
}

export default Footbar;



// WEBPACK FOOTER //
// ./src/components/Footbar.js